import { useMemo } from 'react';
import { t } from '@lingui/macro';
import { makeStyles } from '@material-ui/core';

import DataTable from '../data-table/DataTable';
import { COLUMN_TYPES } from '../data-table/DataTableColumns';
import { useArrayLoader } from '../data-table/Loaders';
import { useFetchProblems } from './FetchProblems';

function getColumns() {
    return [
        {
            type: COLUMN_TYPES.TEXT,
            title: t`Type`,
            mapping: 'type',
            width: 100,
        },
        {
            type: COLUMN_TYPES.PROBLEMLINK,
            title: t`Entity`,
            mapping: 'entity',
            formatter: (value) => value?.name,
            width: 240,
        },
        {
            type: COLUMN_TYPES.STATUS,
            title: t`Status`,
            width: 75,
            mapping: 'severity',
        },
        {
            type: COLUMN_TYPES.TEXT,
            title: t`Description`,
            mapping: 'description',
            flex: 1,
        },
    ];
}

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
});

export default function ProblemsTable({ timeRange, total, entityType, entityUuid }) {
    const classes = useStyles();

    const columns = useMemo(() => getColumns(), []);

    const problemsResult = useFetchProblems(timeRange, entityType, entityUuid, total);

    const loader = useArrayLoader(problemsResult?.result?.data);

    if (!problemsResult) return null;

    if (problemsResult.error) {
        return <div>Error: {`${problemsResult.error}`}</div>;
    }

    return (
        <div className={classes.root}>
            <DataTable tableId="Problems Table" visibleRows={5} loader={loader} columns={columns} />
        </div>
    );
}
